export enum ProfileType {
  none = 'None',
  adult = 'Adult',
  minor = 'Minor',
  company = 'Company'
}
